import { call, put, takeEvery, select } from "redux-saga/effects";
import { clearShoppingRequest } from "../shopping/shopping.actions";
import * as SocialActions from "./social.actions";
import SocialAPI from "./social.api";
import { SocialActionTypes } from "./social.model";
import toastr from "toastr";
import { getUserProfile } from "../user/user.selector";
import Swal from "sweetalert2";

export function* handleCreateLiveStream(action) {
    try {
        const response = yield call(
            SocialAPI.CreateLiveStream,
            action.payload.data
        );
        yield put(
            SocialActions.fetchLiveStreamByIdRequest({
                id: response.data._id,
                history: action.payload.history,
            })
        );
        yield put(clearShoppingRequest());
    } catch (e) {
        yield put(SocialActions.createLiveStreamFailure(e));
    }
}

export function* handleTopLiveStream(action) {
    try {
        const response = yield call(SocialAPI.GetTopRecommend, action.payload);
        yield put(SocialActions.getTopLiveStreamSuccess(response));
    } catch (e) {
        yield put(SocialActions.getTopLiveStreamFailure(e));
    }
}

export function* handleHomeTopLiveStream(action) {
    try {
        const response = yield call(
            SocialAPI.GetTopRecommendHome,
            action.payload
        );
        yield put(SocialActions.getTopHomeLiveStreamSuccess(response));
    } catch (e) {
        yield put(SocialActions.getTopHomeLiveStreamFailure(e));
    }
}

export function* handleRecentLiveStream(action) {
    try {
        const response = yield call(
            SocialAPI.GetLiveStreamList,
            "?where=streamingStatus:Ended"
        );
        yield put(SocialActions.getRecentStreamSuccess(response));
    } catch (e) {
        yield put(SocialActions.getRecentStreamFailure(e));
    }
}

export function* handleJustLiveStream(action) {
    try {
        const response = yield call(
            SocialAPI.GetLiveStreamList,
            "?where=streamingStatus:streaming"
        );
        yield put(SocialActions.getJustStreamSuccess(response));
    } catch (e) {
        yield put(SocialActions.getJustStreamFailure(e));
    }
}

export function* handleFollowingStream(action) {
    try {
        const response = yield call(
            SocialAPI.GetFollowingLiveStream,
            action.payload
        );
        yield put(SocialActions.getFollowingStreamSuccess(response));
    } catch (e) {
        yield put(SocialActions.getFollowingStreamFailure(e));
    }
}

export function* handleFetchLiveStreamByID(action) {
    try {
        const response = yield call(
            SocialAPI.GetLiveStreamById,
            action.payload.id
        );
        yield put(SocialActions.fetchLiveStreamByIdSuccess(response));
        const user = yield select(getUserProfile);
        if (action.payload.history) {
            if (
                user._id === response.data.owner._id &&
                response.data.streamingStatus === "Waiting"
            ) {
                action.payload.history("/page/preview");
            } else if (response.data.streamingStatus === "Ended") {
                action.payload.history("/page/replay");
            } else {
                action.payload.history("/page/livestream");
            }
        }
    } catch (e) {
        yield put(SocialActions.fetchLiveStreamByIdFailure(e));
    }
}
export function* handleFetchLiveStream(action) {
    try {
        const response = yield call(
            SocialAPI.GetLiveStreamList,
            action.payload ? action.payload : ""
        );
        yield put(SocialActions.fetchLiveStreamSuccess(response));
    } catch (e) {
        yield put(SocialActions.fetchLiveStreamFailure(e));
    }
}

export function* handleFetchBookMark(action) {
    try {
        const response = yield call(
            SocialAPI.GetBookMarks,
            action.payload ? action.payload : ""
        );
        yield put(SocialActions.fetchBookMarkSuccess(response));
    } catch (e) {
        yield put(SocialActions.fetchBookMarkFailure(e));
    }
}

export function* handleFetchReaction(action) {
    try {
        const response = yield call(SocialAPI.GetReactionList);
        yield put(SocialActions.fetchReactionSuccess(response));
    } catch (e) {
        yield put(SocialActions.fetchReactionFailure(e));
    }
}

export function* handleCreateBookMark(action) {
    try {
        const response = yield call(SocialAPI.CreateBookMark, action.payload);
        yield put(SocialActions.createBookMarkSuccess(response));
        Swal.fire({
            title: "Bookmark successful",
            text: "This live has been bookmarked",
            icon: "success",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            showConfirmButton: false,
            cancelButtonText: "Close",
            customClass: {
                cancelButton: "order-1 right-gap",
                confirmButton: "order-2",
                denyButton: "order-3",
            },
        });
        yield put(SocialActions.fetchBookMarkRequest());
    } catch (e) {
        yield put(SocialActions.createBookMarkFailure(e));
    }
}

export function* handleDeleteBookMark(action) {
    try {
        yield call(SocialAPI.DeleteBookMark, action.payload);
        Swal.fire({
            title: "Bookmark",
            text: "Bookmark Deleted Successfully",
            icon: "success",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            showConfirmButton: false,
            cancelButtonText: "Close",
            customClass: {
                cancelButton: "order-1 right-gap",
                confirmButton: "order-2",
                denyButton: "order-3",
            },
        });
        yield put(SocialActions.deleteBookMarkSuccess(action.payload));
        yield put(SocialActions.fetchBookMarkRequest());
    } catch (e) {
        yield put(SocialActions.deleteBookMarkFailure(e));
    }
}

export function* handleWowzaCreate(action) {
    try {
        const history = action.payload.history;
        const id = action.payload.id;
        delete action.payload.history;
        const response = yield call(SocialAPI.WowzaCreateEvent, action.payload);
        yield put(SocialActions.createWowzaEventSuccess(response));
        yield put(
            SocialActions.fetchLiveStreamByIdRequest({
                id: id,
                history: history,
            })
        );
        toastr.success("Video is streaming now", "Stay cool");
    } catch (e) {
        yield put(SocialActions.createWowzaEventFailure(e));
    }
}

export function* handleFetchEvents(action) {
    try {
        const response = yield call(SocialAPI.GetEvents, action.payload);
        yield put(SocialActions.fetchEventSuccess(response));
    } catch (e) {
        yield put(SocialActions.fetchEventFailure(e));
    }
}

export function* handleFetchMessages(action) {
    try {
        const response = yield call(SocialAPI.GetPairEvents, action.payload);
        yield put(SocialActions.fetchMessageSuccess(response));
    } catch (e) {
        yield put(SocialActions.fetchMessageFailure(e));
    }
}

export function* handleDeleteLiveStream(action) {
    try {
        yield call(SocialAPI.DeleteLiveStream, action.payload);
        yield put(SocialActions.deleteLiveStreamSuccess(action.payload));
        Swal.fire({
            title: "Success",
            text: "Your video is deleted. ",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "green",
            cancelButtonText: "Cancel",
            confirmButtonText: "Close",
            customClass: {
                cancelButton: "order-1 right-gap",
                confirmButton: "order-2",
                denyButton: "order-3",
            },
        });
    } catch (e) {
        yield put(SocialActions.deleteLiveStreamFailure(e));
    }
}

export function* handleSearchLiveStream(action) {
    try {
        const response = yield call(
            SocialAPI.getSearchedLiveStream,
            action.payload
        );
        yield put(SocialActions.searchLiveStreamSuccess(response));
        action.payload.history("/page/search");
    } catch (e) {
        yield put(SocialActions.searchLiveStreamFailure(e));
    }
}

export function* handleMsgPairUsers(action) {
    try {
        const response = yield call(
            SocialAPI.GetPairMessageEvents,
            action.payload
        );
        yield put(SocialActions.fetchMessageUsersSuccess(response));
    } catch (e) {
        yield put(SocialActions.fetchMessageUsersFailure(e));
    }
}

export function* handleUpdateLiveStream(action) {
    try {
        const response = yield call(
            SocialAPI.UpdateLiveStream,
            action.payload
        );
        yield put(SocialActions.updateLiveStreamSuccess(response));
        Swal.fire({
            title: "Rename successful",
            text: "This live has been Renamed",
            icon: "success",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            showConfirmButton: false,
            cancelButtonText: "Close",
            customClass: {
                cancelButton: "order-1 right-gap",
                confirmButton: "order-2",
                denyButton: "order-3",
            },
        }).then((x)=>{
            if(x.isDismissed){
                document.location.reload();
            }
        });
    } catch (e) {
        yield put(SocialActions.updateLiveStreamFailure(e));
    }
}

export function* handleCloneLiveStream(action) {
    try {
        const response = yield call(
            SocialAPI.CloneLiveStream,
            action.payload
        );
        yield put(SocialActions.cloneLiveStreamSuccess(response));
        document.location.reload();
    } catch (e) {
        yield put(SocialActions.cloneLiveStreamFailure(e));
    }
}

export function* SocialSaga() {
    yield takeEvery(
        SocialActionTypes.CREATE_LIVESTREAM_REQUEST,
        handleCreateLiveStream
    );
    yield takeEvery(
        SocialActionTypes.SEARCH_LIVESTREAM_REQUEST,
        handleSearchLiveStream
    );
    yield takeEvery(
        SocialActionTypes.TOP_RECOMMENDED_LIVESTREAM_REQUEST,
        handleTopLiveStream
    );
    yield takeEvery(
        SocialActionTypes.TOP_RECOMMENDED_HOMELIVESTREAM_REQUEST,
        handleHomeTopLiveStream
    );
    yield takeEvery(
        SocialActionTypes.RECENT_LIVESTREAM_REQUEST,
        handleRecentLiveStream
    );
    yield takeEvery(
        SocialActionTypes.JUST_LIVESTREAM_REQUEST,
        handleJustLiveStream
    );
    yield takeEvery(
        SocialActionTypes.FETCH_LIVESTREAM_ID_REQUEST,
        handleFetchLiveStreamByID
    );
    yield takeEvery(
        SocialActionTypes.FETCH_LIVESTREAM_REQUEST,
        handleFetchLiveStream
    );
    yield takeEvery(
        SocialActionTypes.FETCH_BOOKMARK_REQUEST,
        handleFetchBookMark
    );
    yield takeEvery(
        SocialActionTypes.CREATE_BOOKMARK_REQUEST,
        handleCreateBookMark
    );
    yield takeEvery(
        SocialActionTypes.DELETE_BOOKMARK_REQUEST,
        handleDeleteBookMark
    );
    yield takeEvery(SocialActionTypes.CREATE_WOWZA_REQUEST, handleWowzaCreate);
    yield takeEvery(
        SocialActionTypes.FOLLOWING_LIVESTREAM_REQUEST,
        handleFollowingStream
    );
    yield takeEvery(SocialActionTypes.FETCH_EVENT_REQUEST, handleFetchEvents);
    yield takeEvery(
        SocialActionTypes.FETCH_MESSAGE_REQUEST,
        handleFetchMessages
    );
    yield takeEvery(
        SocialActionTypes.FETCH_REACTION_REQUEST,
        handleFetchReaction
    );
    yield takeEvery(
        SocialActionTypes.DELETE_LIVESTREAM_REQUEST,
        handleDeleteLiveStream
    );
    yield takeEvery(
        SocialActionTypes.FETCH_MSG_USERS_REQUEST,
        handleMsgPairUsers
    );
    yield takeEvery(
        SocialActionTypes.UPDATE_LIVESTREAM_REQUEST,
        handleUpdateLiveStream
    );

    yield takeEvery(
        SocialActionTypes.CLONE_LIVESTREAM_REQUEST,
        handleCloneLiveStream
    );
}
